import * as React from 'react';

const MintdataLogo = (props:any) => (
    <svg width={169} height={23} viewBox="0 0 169 23" {...props}>
        <path
            d="M.944.6h4.48l7.392 14.88L20.176.6h4.448V23h-3.488l-.032-16.736-7.072 14.4h-2.464l-7.072-14.4V23H.944V.6zm29.867 0h3.776V23H30.81V.6zm9.93 0h3.712l12 16.096V.6h3.712V23h-3.712L44.517 6.936V23h-3.776V.6zm22.955 0h17.952v3.392h-7.104V23h-3.776V3.992h-7.072V.6zm30.635 0c6.72 0 11.584 4.704 11.584 11.2 0 6.464-4.896 11.2-11.68 11.2h-9.088V.6h9.184zm.096 19.008c4.352 0 7.68-3.232 7.68-7.776 0-4.576-3.424-7.84-7.84-7.84h-5.344v15.616h5.504zM126.245 23l-2.144-5.056h-11.296L110.661 23h-3.936L116.613.6h3.872l9.792 22.4h-4.032zm-12.032-8.416h8.448l-4.224-9.952-4.224 9.952zM128.656.6h17.952v3.392h-7.104V23h-3.776V3.992h-7.072V.6zm35.85 22.4l-2.143-5.056h-11.296L148.923 23h-3.936L154.875.6h3.872l9.792 22.4h-4.032zm-12.031-8.416h8.448l-4.224-9.952-4.224 9.952z" />
    </svg>
);

export default MintdataLogo;

